import type { DueDiligenceStatus, MinifiedDispensary } from '@gcv/shared';

import { MINIFIED_DISPENSARIES_KEY } from 'tanstack-hooks/keys';
import { queryClient } from 'util/queryClient';

export const updateMinifiedDispensariesStatus = (
  bankId: string,
  crbIds: string[],
  status: DueDiligenceStatus
) => {
  queryClient.setQueryData(
    [MINIFIED_DISPENSARIES_KEY, bankId],
    (dispensaries: MinifiedDispensary[] | undefined) =>
      dispensaries?.map((dispensary) =>
        crbIds.includes(dispensary.id)
          ? {
              ...dispensary,
              assigned_onboarding_template: { ...dispensary.assigned_onboarding_template, status }
            }
          : dispensary
      )
  );
};
